export const noImageUrl =
'https://firebasestorage.googleapis.com/v0/b/upstager-dev.appspot.com/o/noIMage.png?alt=media&token=3a8e11e1-a4d7-423f-8eb1-eb4086c73c3e'
